import { ApplicationConfig, ErrorHandler, importProvidersFrom } from '@angular/core';
import { PreloadAllModules, provideRouter, Router, withPreloading } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { FormlyModule } from '@ngx-formly/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormInputComponent, FormSelectComponent, StepperComponent } from '@sarasanalytics-com/design-system';
import { routes } from './app.routes';
import { provideFirebaseApp } from '@angular/fire/app';
import { initializeApp } from 'firebase/app';
import { environment } from 'src/environments/environment';
import {getAuth, provideAuth} from '@angular/fire/auth';
import { FIREBASE_OPTIONS } from '@angular/fire/compat';
import { CookieModule } from 'ngx-cookie';
import { AuthInterceptor } from './shared/interceptor/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withPreloading(PreloadAllModules)),
    importProvidersFrom([
      provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
      provideAuth(()=> getAuth()),
      FormlyModule.forRoot({
        types: [
          {
            name: 'sa-select',
            component: FormSelectComponent,
          },
          {
            name: 'sa-stepper',
            component: StepperComponent,
          },
          {
            name: 'sa-input',
            component: FormInputComponent
          }
        ]
      }),
      CookieModule.withOptions()
    ]), provideAnimationsAsync(), provideAnimationsAsync(), provideHttpClient(withInterceptorsFromDi()),
    { provide: FIREBASE_OPTIONS, useValue: environment.firebaseConfig },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
  ]
};
